// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"l0-z"};